import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { FaAngleRight } from "react-icons/fa";
import { SUPPORTED_LANGUAGES } from "pages/languageswitcher/languageSwitcher";
import { MENU_ITEM_CLASS, MENU_ITEM_ICON_CLASS, MENU_ITEM_VALUE_CLASS } from "./menuItemStyles";

export default function LanguageMenu() {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const activeCode = (i18n.resolvedLanguage || i18n.language || "en")
    .toLowerCase()
    .split("-")[0];

  const activeLabel =
    SUPPORTED_LANGUAGES.find((language) => language.code === activeCode)?.label ||
    SUPPORTED_LANGUAGES[0].label;

  const handleSelect = (code: string) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((previous) => !previous)}
        className={MENU_ITEM_CLASS}
      >
        <Languages className={MENU_ITEM_ICON_CLASS} aria-hidden="true" />
        <span>{t("Language")}</span>
        <span className={MENU_ITEM_VALUE_CLASS}>
          <span className="max-w-24 truncate">{activeLabel}</span>
          <FaAngleRight
            className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
            aria-hidden="true"
          />
        </span>
      </button>

      {isOpen && (
        <div
          role="listbox"
          className="absolute left-full top-0 ml-1 z-50 w-36 rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-600 dark:bg-gray-700"
        >
          {SUPPORTED_LANGUAGES.map((language) => (
            <button
              key={language.code}
              type="button"
              role="option"
              aria-selected={language.code === activeCode}
              onClick={() => handleSelect(language.code)}
              className={`flex w-full items-center px-4 py-2 text-sm transition-colors ${language.code === activeCode
                ? "text-blue-600 dark:text-blue-400"
                : "text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600"
                }`}
            >
              {language.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
